import { render, staticRenderFns } from "./UnShareBySms.vue?vue&type=template&id=2bf24764&lang=pug&"
import script from "./UnShareBySms.vue?vue&type=script&lang=js&"
export * from "./UnShareBySms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports